import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { withStyles } from "@material-ui/core/styles";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  },
  '& .MuiTypography-root-MuiDialogTitle-root': {
    color: "#16314c"
  }
}));

const CustoDialogActions = withStyles({
  root: {
    backgroundColor: "#fff2d7",
  }
})(DialogActions);

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function InfoOrder(props) {

  const [values, setValues] = React.useState({
    table: null,
    people: null,
    phone: null,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const saveOnclick = () => {
    props.cart.set("order_info", values);
    props.setCart(props.cart);
    props.setIsOpenInfo(false);
  }

  const disableSave = () => {
    return values.table === null || values.people === null || values.phone === null
  }

  return (
    <React.Fragment key={1}>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        open={props.isOpenInfo}
      >
        <BootstrapDialogTitle id="customized-dialog-title" color='#fff2d7' backgroundColor="#404040">
          Benvenuto, qui puoi effetturare un ordine dal tavolo
        </BootstrapDialogTitle>
        <BootstrapDialogTitle backgroundColor="#fff2d7"
          dividers sx={{
            '& .MuiBox-root': { display: 'flex', flexDirection: 'column', alignItems: 'center' },
            '& .MuiDialogContent-root': { backgroundColor: "#fff2d7" }
          }}>
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { m: 1, width: '25ch' },
              '& .MuiFilledInput-root': { color: '#16314c' },
              '& .MuiInputBase-root': { backgroundColor: '#fff2d7' }
            }}
            noValidate
            autoComplete="on"
          >
            <TextField
              id="table"
              onChange={handleChange('table')}
              value={values.table}
              label="Numero del tavolo"
              type="number"
              variant="filled"
            />
            <TextField
              id="people"
              onChange={handleChange('people')}
              value={values.people}
              label="Attuale numero di persone"
              type="number"
              variant="filled"
            />
            <TextField
              id="phone"
              onChange={handleChange('phone')}
              value={values.phone}
              label="Numero di telefono attuale"
              type="number"
              variant="filled"
            />
          </Box>
        </BootstrapDialogTitle>
        <CustoDialogActions sx={{ '& .MuiButton-root': { color: '#fff2d7', backgroundColor: "#404040" } }}>
          <Button autoFocus onClick={saveOnclick} disabled={disableSave()}>
            Save changes
          </Button>
        </CustoDialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}